import { BoxMessageBasketEmpty, MessageBasketEmpty } from "./BasketPage.styles";
import { useTranslation } from "../../../explorer/hooks/useTranslation";

const BasketNoItemPage = () => {
    const { t } = useTranslation();
    return (
        <BoxMessageBasketEmpty>
            <MessageBasketEmpty variant="h5">
                {/*<AppIconsCart fontSize="large" />*/}
                {`${t("basket.isEmpty")}`}
            </MessageBasketEmpty>
        </BoxMessageBasketEmpty>
    );
};

export default BasketNoItemPage;
